import React, { useCallback, useEffect, useState } from 'react'
import OverlayRight, { StyledOverlayInnerWrapper } from '../Page/logix2020/OverlayRight'
import OverlayContainer from '../Page/logix2020/OverlayContainer'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { useTranslation } from 'react-i18next'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { Form, Col, Row, Alert, Spinner } from 'react-bootstrap'
import ArraySelect from '../Select/ArraySelect'
import { makeCall } from '../../utils/api/makeCall'
import apiClient from '../../utils/api/apiClient'
import { ButtonWithLoadingState } from '../Buttons'
import PlusMinusAmount from '../Forms/PlusMinusAmount'
import styled from 'styled-components'
import CustomDatePicker from '../Forms/CustomDatePicker'
import { getIsoDate } from '../../utils/getIsoDate'
import { emptyDate, isEmptyDate } from '../../utils/emptyDate'
import { getErrorMessageFromApiResponse } from "../../utils/api/apiUtils"
import { StyledValidationMessage } from '../Employees/Form/formHelper'
import { Button } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import ArticleSelectModal from '../ArticleSelect/ArticleSelectModal'

const StyledName = styled.div`
  flex-basis: 50%;
`

const ArticleSelect = ({ setSelectedArticleId, handleArticleWasChanged }) => {
  const { t } = useTranslation()
  const [showAddArticlesModal, setShowAddArticlesModal] = useState(false)
  const [selectedArticles, setSelectedArticles] = useState([])
  useEffect(() => {
    if (!selectedArticles.length) {
      setSelectedArticleId(emptyGuid)
    } else {
      setSelectedArticleId(selectedArticles[0].article.id)
    }
  }, [setSelectedArticleId, selectedArticles])
  return (
    <>
      <Button className="w-100 mb-3" onClick={() => setShowAddArticlesModal(true)} disabled={false}><MdLibraryAdd className="me-3" />{t('article_select')}</Button>
      {showAddArticlesModal
        ? <ArticleSelectModal
          selectedArticles={selectedArticles}
          setSelectedArticles={setSelectedArticles}
          setShowAddArticlesModal={setShowAddArticlesModal}
          showAddArticlesModal={showAddArticlesModal}
          handleSave={() => { setShowAddArticlesModal(false); handleArticleWasChanged() }}
          singleSelection={true}
          userOffices={true}
        />
        : null}
    </>

  )
}

const CreateLocalInventoryContent = () => {
  const { t } = useTranslation()
  const [isSaving, setIsSaving] = useState(false)
  const [success, setSuccess] = useState("")
  const [error, setError] = useState("")
  const [storehouses, setStorehouses] = useState([])
  const [articleVariants, setArticleVariants] = useState([])
  const [errorStates, setErrorStates] = useState({})
  const [loadingStates, setLoadingStates] = useState({})
  const [selectedArticleId, setSelectedArticleId] = useState(emptyGuid)
  const [selectedSizeId, setSelectedSizeId] = useState(emptyGuid)
  const [selectedStoreHouseId, setSelectedStoreHouseId] = useState(emptyGuid)
  const [batchKey, setBatchKey] = useState("")
  const [serialkey, setSerialkey] = useState("")
  const [comment, setComment] = useState("")
  const [expiryDate, setExpiryDate] = useState(emptyDate)
  const [article, setArticle] = useState({})
  const [countedQuantity, setCountedQuantity] = useState(1)
  const [currentInventory, setCurrentInventory] = useState({})


  const loadStorehouses = useCallback(async () => {
    makeCall('loadStorehouses', async () => {
      let loadedStorehouses = await apiClient.getJson(APIEndpoints.storehouses())
      setStorehouses(loadedStorehouses.filter(item => item.isVirtual))
    }, setErrorStates, setLoadingStates)

  }, [])
  useEffect(() => {
    loadStorehouses()
  }, [loadStorehouses])
  const loadArtikel = useCallback(async () => {
    makeCall('loadArtikel', async () => {
      let loadedArtikel = await apiClient.getJson(APIEndpoints.article(selectedArticleId))
      setArticle(loadedArtikel)
    }, setErrorStates, setLoadingStates)

  }, [selectedArticleId])
  const loadArtikelVariants = useCallback(async () => {
    makeCall('loadArtikelVariants', async () => {
      let loadedArtikelVariants = await apiClient.getJson(APIEndpoints.articleVariants(selectedArticleId))
      setArticleVariants(loadedArtikelVariants)
    }, setErrorStates, setLoadingStates)

  }, [selectedArticleId])
  const handleArticleWasChanged = async () => {
    let loadArticle = (!isEmptyGuid(selectedArticleId) && article.id != selectedArticleId)
    if (isEmptyGuid(selectedArticleId) || loadArticle) {
      setArticleVariants([])
      setSelectedSizeId(emptyGuid)
      setSelectedStoreHouseId(emptyGuid)
      setArticle({})
      setExpiryDate(emptyDate)
      setSerialkey("")
      setBatchKey("")
      setComment("")
      setCurrentInventory({})
      setCountedQuantity(1)
    }
    if (loadArticle) {
      loadArtikel()
      loadArtikelVariants()
    }
  }
  const loadInventory = useCallback(async () => {
    makeCall('loadInventory', async () => {
      let params = {
        'id.storehouseId': selectedStoreHouseId,
        'id.articleId': selectedArticleId,
        'id.sizeId': selectedSizeId,
        'id.serialkey': serialkey,
        'id.batchKey': batchKey,
      }
      let loadedInventory = await apiClient.getJson(APIEndpoints.localstock().localInventory, params)
      setCurrentInventory(loadedInventory)
      if (loadedInventory) {
        setExpiryDate(loadedInventory.expiryDate)
        setCountedQuantity(loadedInventory.quantity)
      }
    }, setErrorStates, setLoadingStates)
  }, [selectedStoreHouseId, selectedArticleId, selectedSizeId, serialkey, batchKey])
  useEffect(() => {
    if (!isEmptyGuid(selectedStoreHouseId)) {
      loadInventory()
    }
  }, [loadInventory, selectedStoreHouseId])
  const handleChangeDate = (dateForm) => date => {
    if (date instanceof Date) {
      const preparedDate = getIsoDate(date)
      switch (dateForm) {
        case "expiryDate":
          setExpiryDate(preparedDate)
          break;
        default: console.log("Datum kann nicht gespeichert werden")
      }
    }
  }
  const handleOnClickMinus = inv => {
    if (countedQuantity < 1) {
      return
    }
    setCountedQuantity(parseInt(countedQuantity) - 1)
  }

  const handleOnClickPlus = inv => {
    if (article.useSerialKeys && countedQuantity >= 1) {
      return
    }
    setCountedQuantity(parseInt(countedQuantity) + 1)
  }

  const handleOnChangeInventory = inv => {
    const { value } = inv.target
    if (value < 0) {
      return
    }
    if (article.useSerialKeys && value > 1) {
      return
    }
    setCountedQuantity(value)
  }
  const saveData = async () => {
    let params = {
      inventoryChanges: [{
        storehouseId: selectedStoreHouseId,
        articleId: selectedArticleId,
        sizeId: selectedSizeId,
        serialkey: serialkey,
        batchKey: batchKey,
        expiryDate: expiryDate,
        quantity: countedQuantity
      }],
      comment: comment
    }
    return await apiClient.patchJson(APIEndpoints.localstock().localInventories, params)
  }

  const handleSave = async () => {
    setIsSaving(true)
    setError("")
    try {
      await saveData()
      setSuccess(t('EmployeeFormSidebar:dataSaved'))
      loadInventory()
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    setIsSaving(false)
  }

  const selectStorehouseIsDisabled = () => {
    if (isEmptyGuid(selectedArticleId)) return true;
    if (article.isWithSizes && isEmptyGuid(selectedSizeId)) return true;
    if (article.useSerialKeys && !serialkey) return true;
    if (article.useBatchlKeys && !batchKey) return true;
    if (article.useBatchlKeys && isEmptyDate(expiryDate)) return true;
    return false;
  }
  const quantityFieldIsDisabled = () => {
    if (isEmptyGuid(selectedStoreHouseId)) return true;
    return selectStorehouseIsDisabled();
  }
  const saveButtonIsDisabled = () => {
    if (isSaving) return true;
    return quantityFieldIsDisabled();
  }
  if (errorStates.loadStorehouses) console.log('loadStorehouses errorStates:', errorStates.loadStorehouses)
  if (errorStates.loadArtikel) console.log('loadArtikel errorStates:', errorStates.loadArtikel)
  if (errorStates.loadArtikelVariants) console.log('loadArtikelVariants errorStates:', errorStates.loadArtikelVariants)
  useEffect(() => {
    let timer = null
    if (success) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        setSuccess("");
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [setSuccess, success])
  return (
    <>
      <div className="content">
        <Form.Group className="mb-3">
          <Form.Label className="d-block ps-1">{t('createLocalInventory:articleSelection')}</Form.Label>
          <ArticleSelect
            setSelectedArticleId={setSelectedArticleId}
            handleArticleWasChanged={handleArticleWasChanged}
          />
        </Form.Group>
        {!isEmptyGuid(selectedArticleId) &&
          <Form.Group className="mb-3">
            <StyledName>
              <div>{article.displayName}</div>
              <small className='text-uppercase'>{t('inventory:articleNr')}: {article.articleNumber}</small>
            </StyledName>
          </Form.Group>}
        {!isEmptyGuid(selectedArticleId) && loadingStates.loadArtikelVariants
          ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
          : article.isWithSizes ?
            <Form.Group className="mb-3">
              <Form.Label className="d-block ps-1">{t('createLocalInventory:variantSelection')}</Form.Label>
              <ArraySelect
                value={selectedSizeId}
                defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
                defaultOptionIsSelectable
                options={articleVariants}
                noAutoSelect
                onChange={e => setSelectedSizeId(e.target.value)}
                returnEvent
              />
            </Form.Group>
            : null
        }
        {article.useSerialKeys && <Form.Group className="mb-3">
          <Form.Label className='ps-1'>{t(`createLocalInventory:serialkey`)}</Form.Label>
          <Form.Control
            name="serialkey"
            onChange={e => setSerialkey(e.target.value)}
            value={serialkey}
            required
            isInvalid={!serialkey}
          />
          <Form.Control.Feedback type="invalid">
            <StyledValidationMessage>
              {t('createLocalInventory:specifySerialkey')}
            </StyledValidationMessage>
          </Form.Control.Feedback>
        </Form.Group>}
        {article.useBatchlKeys && <Form.Group className="mb-3">
          <Form.Label className='ps-1'>{t(`createLocalInventory:batchKey`)}</Form.Label>
          <Form.Control
            name="batchKey"
            onChange={e => setBatchKey(e.target.value)}
            value={batchKey}
            required
            isInvalid={!batchKey}
          />
          <Form.Control.Feedback type="invalid">
            <StyledValidationMessage>
              {t('createLocalInventory:specifyBatchKey')}
            </StyledValidationMessage>
          </Form.Control.Feedback>
        </Form.Group>
        }
        {article.useBatchlKeys && <Form.Group className="mb-3">
          <Form.Label className='ps-1'>{t('createLocalInventory:expiryDate')}</Form.Label>
          <CustomDatePicker
            dateFormat="dd.MM.yyyy"
            placeholderText={t('date')}
            showYearDropdown
            selected={(!currentInventory && !isEmptyDate(currentInventory.expiryDate)) ? currentInventory.expiryDate : (!isEmptyDate(expiryDate) && new Date(expiryDate)) || ''}
            disabled={!currentInventory && !isEmptyDate(currentInventory.expiryDate)}
            onChange={handleChangeDate('expiryDate')}
            required
            isInvalid={isEmptyDate(expiryDate)}
          />
          <Form.Control.Feedback type="invalid">
            <StyledValidationMessage>
              {t('createLocalInventory:specifyExpiryDate')}
            </StyledValidationMessage>
          </Form.Control.Feedback>
        </Form.Group>}
        <Form.Group className="mb-3">
          <Form.Label className="d-block ps-1">{t('createLocalInventory:warehouseSelection')}</Form.Label>
          {loadingStates.loadStorehouses
            ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
            :
            <ArraySelect
              value={selectedStoreHouseId}
              defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
              defaultOptionIsSelectable
              options={storehouses}
              noAutoSelect
              onChange={e => setSelectedStoreHouseId(e.target.value)}
              returnEvent
              disabled={selectStorehouseIsDisabled()}
            />
          }
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className='ps-1'>{t('createLocalInventory:currentInventory')}</Form.Label>
          <div >
            <Row>
              <Col>
                <b className='ps-1'>{t('localInventoriesTable:current')}: </b>
              </Col>
              <Col>
                {currentInventory ? currentInventory.quantity : "0"}{" "}{currentInventory ? currentInventory.capacityUnitName : article ? article.unit.displayName : ""}
              </Col>
            </Row>
          </div>
          <div>
            <PlusMinusAmount
              placeholder={(currentInventory && currentInventory.quantity) || "1"}
              value={countedQuantity}
              onChange={handleOnChangeInventory}
              onChangePlus={handleOnClickPlus}
              onChangeMinus={handleOnClickMinus}
              disableMinus={!countedQuantity && quantityFieldIsDisabled()}
              disablePlus={quantityFieldIsDisabled()}
              disableField={quantityFieldIsDisabled()}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className='ps-1'>{t('comment')}</Form.Label>
          <Form.Control
            as="textarea"
            placeholder=""
            value={comment}
            onChange={e => setComment(e.target.value)}
            name="comment"
            disabled={quantityFieldIsDisabled()}
          />
        </Form.Group>
      </div>
      {error ? <Alert variant="danger">{error}</Alert> : null}
      {success ? <Alert variant="success">{success}</Alert> : null}
      <div className="footer p-4" >
        <ButtonWithLoadingState
          className="submit-btn my-3"
          disabled={saveButtonIsDisabled()}
          buttonText={t('saveButton')}
          loadingText={t('createLocalInventory:saveLocalInventory')}
          isLoading={isSaving}
          onClick={handleSave}
        />
      </div>
    </>
  )
}

const CreateLocalInventoryOverlay = ({ visible, onClose, ...rest }) => {
  const { t } = useTranslation()

  return (
    <OverlayContainer>
      <OverlayRight visible={visible} onClose={onClose} headerTitle={t('createLocalInventory:createLocalInventory')}>
        <StyledOverlayInnerWrapper>
          {visible && <CreateLocalInventoryContent {...rest} />}
        </StyledOverlayInnerWrapper>
      </OverlayRight>
    </OverlayContainer>

  )
}

export default CreateLocalInventoryOverlay